import { Node } from "@tiptap/core";

export const LoomVideo = Node.create({
  name: "loom",

  group: "block",
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      src: {
        default: null,
      },
      width: {
        default: 640,
      },
      height: {
        default: 360,
      },
      align: {
        default: "center",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "iframe[data-loom]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      {
        "data-loom-wrapper": "true",
        class: "tt-loom-wrapper",
      },
      [
        "iframe",
        {
          ...HTMLAttributes,
          "data-loom": "true",
          frameborder: "0",
          allow:
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: "true",
          src: HTMLAttributes.src,
          width: HTMLAttributes.width,
          height: HTMLAttributes.height,
        },
      ],
    ];
  },
});
